export const LIST_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST = 'LIST_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST'
export const LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS = 'LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS'
export const LIST_MCU_PROJECT_SUMMARY_GENERATOR_FAIL = 'LIST_MCU_PROJECT_SUMMARY_GENERATOR_FAIL'

export const LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_REQUEST = 'LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_REQUEST'
export const LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_SUCCESS = 'LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_SUCCESS'
export const LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_FAIL = 'LIST_MCU_PROJECT_SUMMARY_GENERATOR_SUMMARY_FAIL'

export const CREATE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST = 'CREATE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST'
export const CREATE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS = 'CREATE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS'
export const CREATE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL = 'CREATE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL'

export const DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST = 'DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST'
export const DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS = 'DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS'
export const DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_FAIL = 'DETAIL_MCU_PROJECT_SUMMARY_GENERATOR_FAIL'

export const UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST = 'UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST'
export const UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS = 'UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS'
export const UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL = 'UPDATE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL'

export const DELETE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST = 'DELETE_MCU_PROJECT_SUMMARY_GENERATOR_REQUEST'
export const DELETE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS = 'DELETE_MCU_PROJECT_SUMMARY_GENERATOR_SUCCESS'
export const DELETE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL = 'DELETE_MCU_PROJECT_SUMMARY_GENERATOR_FAIL'

export const RESET_MCU_PROJECT_PACKAGE = 'RESET_MCU_PROJECT_PACKAGE'

export const LIST_PARTNER_SUMMARY_GENERATOR_REQUEST = 'LIST_PARTNER_SUMMARY_GENERATOR_REQUEST'
export const LIST_PARTNER_SUMMARY_GENERATOR_SUCCESS = 'LIST_PARTNER_SUMMARY_GENERATOR_SUCCESS'
export const LIST_PARTNER_SUMMARY_GENERATOR_FAIL = 'LIST_PARTNER_SUMMARY_GENERATOR_FAIL'

export const CREATE_PARTNER_SUMMARY_GENERATOR_REQUEST = 'CREATE_PARTNER_SUMMARY_GENERATOR_REQUEST'
export const CREATE_PARTNER_SUMMARY_GENERATOR_SUCCESS = 'CREATE_PARTNER_SUMMARY_GENERATOR_SUCCESS'
export const CREATE_PARTNER_SUMMARY_GENERATOR_FAIL = 'CREATE_PARTNER_SUMMARY_GENERATOR_FAIL'

export const DETAIL_PARTNER_SUMMARY_GENERATOR_REQUEST = 'DETAIL_PARTNER_SUMMARY_GENERATOR_REQUEST'
export const DETAIL_PARTNER_SUMMARY_GENERATOR_SUCCESS = 'DETAIL_PARTNER_SUMMARY_GENERATOR_SUCCESS'
export const DETAIL_PARTNER_SUMMARY_GENERATOR_FAIL = 'DETAIL_PARTNER_SUMMARY_GENERATOR_FAIL'